import React, { useState, useRef } from 'react';
import { projects } from '../data.js';
import { FaGithub, FaExternalLinkAlt } from 'react-icons/fa';
import { HiChevronDown } from 'react-icons/hi';

export default function Projects({ sectionBg }) {
  const [showAll, setShowAll] = useState(false);
  const sectionRef = useRef(null);
  const projectsPerRow = 3;
  const initialCount = projectsPerRow * 2;

  const sortedProjects = [...projects].sort((a, b) => new Date(b.date) - new Date(a.date));
  const displayedProjects = showAll ? sortedProjects : sortedProjects.slice(0, initialCount);
  const cardBg = sectionBg === "bg-gray-50" ? "bg-white" : "bg-gray-50";

  const handleToggle = () => {
    setShowAll(prev => {
      if (prev) sectionRef.current?.scrollIntoView({ behavior: 'smooth' });
      return !prev;
    });
  };

  return (
    <section ref={sectionRef} id="projects" className={sectionBg + ' py-16'}>
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-3xl font-bold mb-8 text-center">Projects</h2>
        <div className="grid md:grid-cols-3 gap-8">
          {displayedProjects.map((proj, index) => (
            <div key={index} className={`${cardBg} p-6 rounded-xl shadow-md hover:shadow-lg transition transform hover:-translate-y-1 flex flex-col justify-between`}>
              <div>
                <h3 className="text-xl font-semibold" dangerouslySetInnerHTML={{ __html: proj.title }} />
                <p className="italic text-gray-500 mt-1" dangerouslySetInnerHTML={{ __html: proj.date }} />
                <p className="mt-2 text-gray-700" dangerouslySetInnerHTML={{ __html: proj.description }} />
                {proj.results?.length > 0 && (
                  <>
                    <h4 className="mt-2 text-gray-700 font-semibold">Achievements:</h4>
                    <ul className="pl-5 list-disc text-gray-700">
                      {proj.results.map((res, i) => <li key={i} dangerouslySetInnerHTML={{ __html: res }} />)}
                    </ul>
                  </>
                )}
              </div>
              <div className="mt-4 flex space-x-4">
                {proj.repo && <a href={proj.repo} target="_blank" rel="noreferrer" className="flex items-center text-gray-700 hover:text-gray-900 transition"><FaGithub className="mr-2"/> GitHub</a>}
                {proj.demo && <a href={proj.demo} target="_blank" rel="noreferrer" className="flex items-center text-gray-700 hover:text-gray-900 transition"><FaExternalLinkAlt className="mr-2"/> Demo</a>}
              </div>
            </div>
          ))}
        </div>

        {projects.length > initialCount && (
          <div className="mt-6 text-center">
            <button onClick={handleToggle} className="p-2 rounded-full bg-blue-600 text-white hover:bg-blue-700 transition transform">
              <HiChevronDown className={`w-6 h-6 transition-transform duration-300 ${showAll ? 'rotate-180' : ''}`} />
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
